﻿import { rootElement } from '@shared/setup';
import Groups from './Groups.vue';

const init = async () => {
    rootElement({
        name: 'account-groups', // pascal, camel & kebab-case are valid
        component: Groups,
        vm: {},
        contextComponents: ['<div>waiting</div>'],
    });
};
init();
